export default __webpack_public_path__ + "static/media/motoMobile.a8e9ebaf.png";